export default [
  {
    path: "/pages/coming-soon",
    name: "coming-soon",
    meta: {
      title: "Coming Soon",
      authRequired: true,
      allowAccess: ["*"],
      page: "admin",
      breadcrumb: {
        vi: [
          {
            text: localStorage.probeName,
            href: "/home",
          },
          {
            text: "Coming soon ",
            href: "",
          },
        ],
        en: [
          {
            text: localStorage.probeName,
            href: "/home",
          },
          {
            text: "Coming soon ",
            href: "",
          },
        ],
      },
    },
    component: () => import("../views/pages/coming-soon"),
  },
  {
    path: "/no-permission",
    name: "No permission",
    component: () => import("../views/pages/no-permission.vue"),
    meta: {
      title: "No permission",
      allowAccess: ["*"],
      page: "auth",
      breadcrumb: {
        vi: [
          {
            text: "",
            href: "/",
          },
        ],
        en: [
          {
            text: "",
            href: "/",
          },
        ],
      },
    },
  },
  {
    path: "/error",
    name: "Error",
    component: () => import("../views/pages/404.vue"),
    meta: {
      title: "Error",
      allowAccess: ["*"],
      page: "auth",
      breadcrumb: {
        vi: [
          {
            text: "",
            href: "/",
          },
        ],
        en: [
          {
            text: "",
            href: "/",
          },
        ],
      },
    },
  },
  {
    path: "/session-time-out",
    name: "session-time-out",
    meta: {
      title: "Session Time Out",
      authRequired: true,
      allowAccess: ["*"],
      page: "admin",
    },
    component: () => import("../views/session-time-out/session-time-out.vue"),
  },  
  
  
  {
    path: "/",
    name: "Home",
    redirect: "/cem-brcd/bao-cao",
  },
  {
    path: "/a",
    name: "Feature A",
    meta: {
      title: "Feature A",
      authRequired: true,
      allowAccess: ["Admin", "TicketManager"],
      page: "admin",
      breadcrumb: {
        vi: [
          {
            text: "Chức năng A",
            href: "/a",
          },
        ],
        en: [
          {
            text: "Feature A",
            href: "/a",
          },
        ],
      },
    },
    component: () => import("../views/a/a.vue"),
  },
  {
    path: "/cem-brcd/phieu-don-le",
    name: "CemBrcdPhieuDonLe",
    meta: {
      title: "Phiếu đơn lẻ",
      authRequired: true,
      allowAccess: ["Admin", "AdminPrimary", "TicketManager"],
      page: "admin",
      breadcrumb: {
        vi: [
          {
            text: "CEM BRCĐ",
            href: "",
          },
          {
            text: "Phiếu đơn lẻ",
            href: "/cem-brcd/phieu-don-le",
          },
        ],
        en: [
          {
            text: "CEM BRCD",
            href: "",
          },
          {
            text: "Single Tickets",
            href: "/cem-brcd/phieu-don-le",
          },
        ],
      },
    },
    component: () => import("../views/cem-brcd/phieu-don-le.vue"),
  },
  {
    path: "/cem-brcd/dien-rong-vtt",
    name: "CemBrcdDienRongVtt",
    meta: {
      title: "Diện rộng VTT",
      authRequired: true,
      allowAccess: ["Admin", "AdminPrimary", "TicketManager"],
      page: "admin",
      breadcrumb: {
        vi: [
          {
            text: "CEM BRCĐ",
            href: "",
          },
          {
            text: "Diện rộng VTT",
            href: "/cem-brcd/dien-rong-vtt",
          },
        ],
        en: [
          {
            text: "CEM BRCD",
            href: "",
          },
          {
            text: "Large Scale VTT",
            href: "/cem-brcd/dien-rong-vtt",
          },
        ],
      },
    },
    component: () => import("../views/cem-brcd/dien-rong-vtt.vue"),
  },
  {
    path: "/cem-brcd/dien-rong-net",
    name: "CemBrcdDienRongNet",
    meta: {
      title: "Diện rộng Net",
      authRequired: true,
      allowAccess: ["Admin", "AdminPrimary", "TicketManager"],
      page: "admin",
      breadcrumb: {
        vi: [
          {
            text: "CEM BRCĐ",
            href: "",
          },
          {
            text: "Diện rộng Net",
            href: "/cem-brcd/dien-rong-net",
          },
        ],
        en: [
          {
            text: "CEM BRCD",
            href: "",
          },
          {
            text: "Large Scale Net",
            href: "/cem-brcd/dien-rong-net",
          },
        ],
      },
    },
    component: () => import("../views/cem-brcd/dien-rong-net.vue"),
  },
  {
    path: "/cem-brcd/bao-cao",
    name: "CemBrcdBaoCao",
    meta: {
      title: "Báo cáo xử lý phiếu",
      authRequired: true,
      allowAccess: ["Admin", "AdminPrimary", "TicketManager"],
      page: "admin",
      breadcrumb: {
        vi: [
          {
            text: "CEM BRCĐ",
            href: "",
          },
          {
            text: "Báo cáo xử lý phiếu",
            href: "/cem-brcd/bao-cao",
          },
        ],
        en: [
          {
            text: "CEM BRCD",
            href: "",
          },
          {
            text: "Ticket Processing Report",
            href: "/cem-brcd/bao-cao",
          },
        ],
      },
    },
    component: () => import("../views/cem-brcd/bao-cao.vue"),
  },
  {
    path: "/cem-brcd/bao-cao-tong-hop",
    name: "CemBrcdBaoCaoTongHop",
    meta: {
      title: "Báo cáo tổng hợp",
      authRequired: true,
      allowAccess: ["Admin", "AdminPrimary", "TicketManager"],
      page: "admin",
      breadcrumb: {
        vi: [
          {
            text: "CEM BRCĐ",
            href: "",
          },
          {
            text: "Báo cáo tổng hợp",
            href: "/cem-brcd/bao-cao-tong-hop",
          },
        ],
        en: [
          {
            text: "CEM BRCD",
            href: "",
          },
          {
            text: "Report Summary",
            href: "/cem-brcd/bao-cao-tong-hop",
          },
        ],
      },
    },
    component: () => import("../views/cem-brcd/bao-cao-tong-hop.vue"),
  },
  {
    path: "/b",
    name: "Feature B",
    meta: {
      title: "Feature B",
      authRequired: true,
      allowAccess: ["Admin", "TicketManager"],
      page: "admin",
      breadcrumb: {
        vi: [
          {
            text: "Chức năng B",
            href: "/b",
          },
        ],
        en: [
          {
            text: "Feature B",
            href: "/b",
          },
        ],
      },
    },
    component: () => import("../views/b/b.vue"),
  },
];
